module.exports = "/static/assets/830c41fe6ccee48f10aada1895795874.png";